import { render, staticRenderFns } from "./review_implementation.vue?vue&type=template&id=8ac8a29a&scoped=true&"
import script from "./review_implementation.vue?vue&type=script&lang=js&"
export * from "./review_implementation.vue?vue&type=script&lang=js&"
import style0 from "./review_implementation.vue?vue&type=style&index=0&id=8ac8a29a&lang=less&scoped=true&"
import style1 from "./review_implementation.vue?vue&type=style&index=1&id=8ac8a29a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac8a29a",
  null
  
)

export default component.exports